import firebase from 'firebase/compat/app';
import * as firebaseui from 'firebaseui'
import 'firebaseui/dist/firebaseui.css'
import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
const firebaseConfig = {
    apiKey: "AIzaSyCbtrCyprcZJldq9WjJ188TyPVaQEe6Y60",
    authDomain: "firstapp-2a932.firebaseapp.com",
    projectId: "firstapp-2a932",
    storageBucket: "firstapp-2a932.appspot.com",
    messagingSenderId: "1026774944202",
    appId: "1:1026774944202:web:1ca5de2960dbde83dfe733",
    measurementId: "G-5SNH9PH6BY"
};
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig)
    firebase.$ui = new firebaseui.auth.AuthUI(firebase.auth())
}

export default firebase



